import getABTestValue from '@/js/common/Domain/Service/getABTestValue';
import errorHandlerService from './errorHandler';
import requestService from './request';

//todo url должен определятся внутри, а не приходить снаружи, т.к это нарушает лееринг
export default class SessionStatusService {
  constructor(sessionId, callback, params, url = '/frontend/tours/asyncSearch/') {
    this.url = params.isGroupSearch ? '/frontend/groupedTours/asyncSearch/' : url;
    this.waitingTime = 60000;
    this.responseDelay = 3000;
    this.statusTimeout = null;
    this.statusXHR = null;
    this.middleAlreadySent = false;

    this.productMode = params.productMode || false;
    this.toursDone = false;
    this.hotelOffersDone = false;

    this._getStatus({
      params,
      sessionId,
      callback,
    });
    this._initTimeout(params, callback);
  }

  _initTimeout(params, callback) {
    this.globalStatusTimeout = setTimeout(() => {
      clearTimeout(this.statusTimeout);
      if (this.statusXHR && this.statusXHR.readyState !== 4) {
        this.statusXHR.abort();
      }

      //callback.error(null,'Waiting time is up!',null);
      errorHandlerService('Search session waiting time is up!');

      if (this.productMode) {
        this.forceToursDone(params, callback);
        this.forceHotelOffersDone(callback);
        return;
      }

      //get all tours even time is up
      const { asyncStatus } = params;
      if (asyncStatus) {
        asyncStatus.jobsSuccess = asyncStatus.jobsCount;
      }
      callback.success();
    }, this.waitingTime);

    params.globalStatusTimeouts.push(this.globalStatusTimeout);
  }

  forceToursDone(params, callback) {
    if (this.toursDone) {
      return;
    }
    this.toursDone = true;
    const { asyncStatus } = params;
    if (asyncStatus) {
      asyncStatus.jobsSuccess = asyncStatus.jobsCount;
    }
    callback?.success?.();
  }

  forceHotelOffersDone(callback) {
    if (this.hotelOffersDone) {
      return;
    }
    this.hotelOffersDone = true;
    callback?.hotelOffersSuccess?.();
  }

  _getStatus({ params, sessionId, callback }) {
    const { originalSearchUuid, searchUuid } = params;
    this.statusXHR = this._getSessionStatusAjax({
      sessionId,
      searchUuid,
      originalSearchUuid,
      callback: {
        success: (response) => {
          const data = response.result ?? response.data;

          if (response.success !== true) {
            this.scheduleNextStatus({ params, sessionId, callback });
            callback?.error?.(null, response.message, null);
            return;
          }

          if (this.productMode) {
            this.handleProductsResponse({
              data,
              params,
              sessionId,
              callback,
            });
          } else {
            this.handleLegacyResponse({
              data,
              params,
              sessionId,
              callback,
            });
          }
        },
        error: () => {
          this.scheduleNextStatus({ params, sessionId, callback });
        },
      },
    });

    params.asyncAjaxRequests.push(this.statusXHR);
    params.ajaxRequests.push(this.statusXHR);
  }

  handleLegacyResponse({ data, params, sessionId, callback }) {
    const { asyncStatus } = params;
    let lastJobsSuccess = Infinity;

    if (asyncStatus) {
      if (data.jobsSuccess > data.jobsCount) {
        // console.log(`jobsSuccess: ${data.jobsSuccess}, jobsCount: ${data.jobsCount}`);
        // TrackJS.track('Wrong jobsCount');
      }

      lastJobsSuccess = asyncStatus.jobsSuccess;
      asyncStatus.jobsCount = Number.parseInt(data.jobsCount, 10);
      asyncStatus.jobsSuccess = Number.parseInt(data.jobsSuccess, 10);
      asyncStatus.operators = data?.tracking?.operators || {};
    }

    if (data.jobsCount === data.jobsSuccess) {
      clearTimeout(this.globalStatusTimeout);
      callback?.success?.();
      return;
    }

    this.scheduleNextStatus({ params, sessionId, callback });

    this.sendMiddleRequestIfNeeded({
      jobsCount: data.jobsCount,
      jobsSuccess: data.jobsSuccess,
      lastJobsSuccess,
      middleRequestsBehavior: params.middleRequestsBehavior,
      callback,
    });
  }

  handleProductsResponse({ data, params, sessionId, callback }) {
    const { asyncStatus } = params;

    const toursBlock = data.products?.tours || { jobsCount: data.jobsCount, jobsSuccess: data.jobsSuccess };
    const hotelOffersBlock =
      data.products?.hotelOffers ||
      (data.products ? null : { jobsCount: data.jobsCount, jobsSuccess: data.jobsSuccess });

    const lastToursJobsSuccess = asyncStatus ? asyncStatus.jobsSuccess : Infinity;
    if (asyncStatus) {
      asyncStatus.jobsCount = Number.parseInt(toursBlock.jobsCount, 10);
      asyncStatus.jobsSuccess = Number.parseInt(toursBlock.jobsSuccess, 10);
      asyncStatus.operators = data?.tracking?.operators || {};
    }

    const toursComplete = this.isBlockComplete(toursBlock);
    const hotelOffersComplete = this.isBlockComplete(hotelOffersBlock);

    if (!this.toursDone && toursComplete) {
      this.toursDone = true;
      callback?.success?.();
    } else if (!this.toursDone) {
      this.sendMiddleRequestIfNeeded({
        jobsCount: toursBlock.jobsCount,
        jobsSuccess: toursBlock.jobsSuccess,
        lastJobsSuccess: lastToursJobsSuccess,
        middleRequestsBehavior: params.middleRequestsBehavior,
        callback,
      });
    }

    if (!this.hotelOffersDone && hotelOffersComplete) {
      this.hotelOffersDone = true;
      callback?.hotelOffersSuccess?.();
    }

    if (this.toursDone && this.hotelOffersDone) {
      clearTimeout(this.globalStatusTimeout);
      return;
    }

    this.scheduleNextStatus({ params, sessionId, callback });
  }

  isBlockComplete(block) {
    if (!block) {
      return false;
    }
    return block.jobsCount === block.jobsSuccess;
  }

  sendMiddleRequestIfNeeded({ jobsCount, jobsSuccess, lastJobsSuccess, middleRequestsBehavior, callback }) {
    if (middleRequestsBehavior === 'halfJobs') {
      const halfJobsReached = jobsSuccess > jobsCount / 2;
      if (halfJobsReached && !this.middleAlreadySent) {
        this.middleAlreadySent = true;
        callback?.middleRequest?.();
      }
      return;
    }

    const hasNewSuccessfulJob = lastJobsSuccess < jobsSuccess;
    if (hasNewSuccessfulJob) {
      callback?.middleRequest?.();
    }
  }

  scheduleNextStatus({ params, sessionId, callback }) {
    this.statusTimeout = setTimeout(() => {
      this._getStatus({
        params,
        sessionId,
        callback,
      });
    }, this.responseDelay);

    params.statusTimeouts.push(this.statusTimeout);
  }

  _getSessionStatusAjax(options) {
    const requestOptions = {
      cache: false,
      data: {
        searchUuid: options.searchUuid,
        abTests: getABTestValue(),
      },
      url: `${window.appConfig.apiGatewayUrl}${this.url}${encodeURIComponent(options.sessionId)}`,
    };

    return requestService(requestOptions, options.callback);
  }
}
